import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from "@angular/core";
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Injectable({
  providedIn: 'root'
})

export class SecretAuthGuardService implements CanActivate {

  constructor(private router: Router,
    private storageConfiguration: StorageConfiguration,
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let isloggedIn = this.storageConfiguration.sessionGetItem(this.storageConfiguration.isloggedIn);
    if (isloggedIn == 'true') {
      return true;
    }
    this.router.navigate(['secret']);
    return false;
  }
}